<button class="btn btn-primary btn-delta-report" (click)="onBtnClick()">
  <span class="pi pi-home"></span>
  <span style="float:right">{{'COMPONENTS.ToDeltaReport' | translate}}</span>
</button>
